import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)
// 解决导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const routes = [
    {
        path: '/',
        redirect: 'home'
    },
    {
        path: '/home',
        name: 'Home',
        component: Home,
        meta: {
            requireAuth: false, // 是否需要登录
            title: "首页" // 文本名字
        },
    },
    {
        path: '/classicCases',
        name: 'classicCases',
        component: () => import('../views/classicCases.vue'),
        meta: {
            requireAuth: false, // 是否需要登录
            title: "服务内容" // 文本名字
        },
    },
    {
        path: '/expertThinkTank',
        name: 'expertThinkTank',
        component: () => import('../views/expertThinkTank.vue'),
        meta: {
            requireAuth: false, // 是否需要登录
            title: "专家智库" // 文本名字
        },
    },
    {
        path: '/serviceCase',
        name: 'serviceCase',
        component: () => import('../views/serviceCase.vue'),
        meta: {
            requireAuth: false, // 是否需要登录
            title: "服务案例" // 文本名字
        },
    },
    {
        path: '/information',
        name: 'information',
        component: () => import('../views/information.vue'),
        meta: {
            requireAuth: false, // 是否需要登录
            title: "资讯中心" // 文本名字
        },
    },
    {
        path: '/regardDH',
        name: 'regardDH',
        component: () => import('../views/regardDH.vue'),
        meta: {
            requireAuth: false, // 是否需要登录
            title: "关于鼎宏" // 文本名字
        },
    },
    {
        path: '/joinDH',
        name: 'joinDH',
        component: () => import('../views/joinDH.vue'),
        meta: {
            requireAuth: false, // 是否需要登录
            title: "加入鼎宏" // 文本名字
        },
    },
    {
        path: '/concatUs',
        name: 'concatUs',
        component: () => import('../views/concatUs.vue'),
        meta: {
            requireAuth: false, // 是否需要登录
            title: "联系方式" // 文本名字
        },
    },
    {
        path: '/articleDetail',
        name: 'articleDetail',
        component: () => import('../views/articleDetail.vue'),
        meta: {
            requireAuth: false, // 是否需要登录
            title: "文章详情" // 文本名字
        },
    },
   

]

const router = new VueRouter({
    linkActiveClass: 'router-link-active',//配置激活时要使用的类名
    mode: 'history',
    routes
})

router.beforeEach((to, from, next) => {
    // if (to.matched.some(res => res.meta.requireAuth)) {
    //   // 判断是否需要登录权限
    //   if (sessionStorage.getItem("token")) {
    //     next();
    //   } else {
    //     // 没登录则跳转到登录界面
    //     next("/login");
    //   }
    // } else {
    //   next();
    // }
    next();
});

export default router
